// dateHelpers.js
import dayjs from "dayjs";

export const disableFutureDates = (current) => {
    return current && current > dayjs().endOf("day");
};

export const disablePastDates = (current) => {
    return current && current < dayjs().startOf("day");
};
